import { Box, Flex, Text, Input, FormControl, FormLabel, Link, Image, FormErrorMessage, InputRightElement, InputGroup } from '@chakra-ui/react';
import Logo from "../../assets/images/hrms_logo.svg";
import Sdlc from "../../assets/images/sdlc.svg";
import MyDiv from './login.style';
import { CustomButton, CustomToast } from '../../components';
import { useForm } from 'react-hook-form';
import { ILog } from './model';
import { useFetch } from '../../hooks/useFetch';
import { ILogin, useAuth } from '../../hooks/useAuth';
import * as routesNames from '../../constants/routes';
import { useNavigate } from "react-router-dom";
import { Icon } from '@chakra-ui/react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import { useState } from 'react';
import { createGlobalStyle } from 'styled-components';

const Login = () => {
  const { addToast } = CustomToast();
  const { login } = useAuth();
  const { fetchApi, loading } = useFetch(addToast);
  const { handleSubmit, register, formState: { errors } } = useForm<ILog>();
  const [show, setShow] = useState(false);
  const { loginObj, hasPermission } = useAuth();
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [loginError, setLoginError] = useState("");

  const handleShow = () => setShow(!show)

  async function onSubmit(values: ILog) {
    const result = await fetchApi<ILogin>('user/login', 'POST', values, null, 'LoggedIn Successfully');
    if (result) {
      if (result.isFirstLogin) {
        navigate(routesNames.FORGOTPASSWORD);
        return;
      }
      sessionStorage.setItem("loginData", JSON.stringify(result));
      const loginData = JSON.parse(sessionStorage.getItem("loginData") || "{}");
      const employeeId = loginData.employeeId;
      const ssoData = await fetchApi("IVR/sso-login", "GET", null, `employeeId=${employeeId}`, "");
      if (ssoData?.urls) {
        const newTab = window.open("", "_blank");
        if (newTab) {
          console.log(1)
          newTab.location.href = ssoData.urls;
        }
      }
      login(result);
    } else {
      const attempts = loginAttempts + 1;
      setLoginAttempts(attempts);

      if (attempts >= 3) {
        setLoginError(
          "Maximum attempts reached. Reset your password"
        );
        return;
      }
    }
  }



  const navigate = useNavigate();
  const handleClick = () => {
    navigate(routesNames.FORGOTPASSWORD)
  }
  return (
    <MyDiv>
      <Box className="login-container">
        <Flex className="login-flex-wrapper">
          {/* Left Section */}
          <Box className="login-left">
            <Image src={Logo} alt="HRLENSE Logo" className="login-logo" />
            <Box className="login-left-content" >
              <Text className="login-heading font-poppins text_bold text_5xl txt common_color">{"Login into\nyour account"}</Text>
              <Text className="login-subheading font-poppins text_regular text_xl low_txt font_dark">
                {"Please log in to your account to\ncontinue managing your workforce."}
              </Text>
            </Box>
            <Image src={Sdlc} alt="SDLC Illustration" className="login-illustration" />
          </Box>

          {/* Right Section */}
          <Box className="login-right">
            <Box className="login-card">
              <Text className='login-title font-poppins text_semibold text_xl font_dark'>Please enter your Login Details</Text>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Box className="form-group">
                  <FormControl id="email" isInvalid={!!errors.email}>
                    <FormLabel className='font-poppins text_medium text_md font_dark'>Email</FormLabel>
                    <Input className="input text_regular font-poppins text_sm font_dark" placeholder="Please Enter Your Email Id"
                      {...register('email', { required: 'Email is required' })} />
                    <FormErrorMessage>{errors.email && errors.email.message}</FormErrorMessage>
                  </FormControl>
                </Box>

                <Box className="form-group">
                  <FormControl id="password" isInvalid={!!errors.password}>
                    <FormLabel className='font-poppins text_medium text_md font_dark'>Password</FormLabel>

                    <InputGroup>
                      <Input className="input text_regular font-poppins text_sm font_dark"
                        type={show ? 'text' : 'password'}
                        placeholder="Please Enter Your Password"
                        {...register('password', { required: 'Password is required' })} />
                      <InputRightElement
                        className="eye-icon"
                        cursor="pointer"
                        onMouseDown={() => setShow(true)}
                        onMouseUp={() => setShow(false)}
                        onMouseLeave={() => setShow(false)}
                        onTouchStart={() => setShow(true)}
                        onTouchEnd={() => setShow(false)}
                      >
                        {show ? <Icon as={ViewIcon} /> : <Icon as={ViewOffIcon} />}
                      </InputRightElement>


                    </InputGroup>
                    <FormErrorMessage>{errors.password && errors.password.message}</FormErrorMessage>
                    {loginAttempts >= 3 && (
                      <Text color="red.500" fontSize="sm" mt={2} className="font-poppins text_xsm text_medium" >
                        {loginError}
                      </Text>
                    )}
                  </FormControl>
                </Box>

                <Flex justify="flex-end" mt={1}>
                  <Link className='forgot-link font-poppins text_sm text_medium font_dark' onClick={handleClick}>Forgot Password?</Link>
                </Flex>

                <Box className="form-group">
                  <CustomButton isLoading={loading} type="submit" title="Login" className='login-button font-poppins btn_theme:hover btn_theme' isDisabled={loginAttempts >= 3} />
                </Box>
              </form>
            </Box>
          </Box>
        </Flex>
      </Box>
    </MyDiv>
  )
}
export default Login